import { collection, getDocs, getFirestore, orderBy, query, where } from "firebase/firestore";
import { Season } from "src/types/season";
import { Round, Tournament } from "src/types/tournament";
import firebaseClient from "./firebase";


class TournamentService {
    collectionName = "tournament";
    db = getFirestore(firebaseClient);

    // Get all documents from a collection
    getAll = async (): Promise<Tournament[]> => {
        const querySnapshot = await getDocs(collection(this.db, this.collectionName));
        return querySnapshot.docs.map(doc => {
            return {
                ...doc.data(),
                id: doc.id
            } as Tournament;
        });
    }

    findBySeason = async (season: Season): Promise<Tournament[]> => {
        const tournamentRef = collection(this.db, this.collectionName);
        const tourQuery = query(tournamentRef, where('seasonId', '==', season.id));
        const querySnapshot = await getDocs(tourQuery);
        const tournaments: Tournament[] = [];
        querySnapshot.forEach((doc) => {
            tournaments.push(doc.data() as Tournament);
        });
        return tournaments.sort((a, b) => {
            if (a.date < b.date) {
                return -1;
            } else if (a.date > b.date) {
                return 1;
            }
            return a.type.localeCompare(b.type);
        });
    }

    getLast = async (): Promise<Tournament | undefined> => {
        const tourQuery = query(collection(this.db, this.collectionName), orderBy("date", "desc"));
        const querySnapshot = await getDocs(tourQuery);
        if (!querySnapshot.empty) {
            const doc = querySnapshot.docs[0];
            return {
                ...doc.data(),
                id: doc.id
            } as Tournament;
        } else {
            return undefined;
        }
    }

    sortRounds(r1: Round, r2: Round) {
        if (r1.total === 0) {
            return 1;
        }
        if (r2.total === 0) {
            return 1;
        }
        return r1.totalNet - r2.totalNet;
    }

}

const tournamentService = new TournamentService();
export { tournamentService };

